import i18n from "../../../../constants/i18n";
import { ON_CALL_TEAM_HEADERS } from "../../../../constants/table-custom-headers/Developers";
import getOnCallTeamStore from "../../../../stores/developer-store/on-call-team-store";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import Et3Table from "../../../../core/et3-table";

const OnCallTeamData = withLiteObserverAndTheme(() => {
  const onCallTeamMembers = getOnCallTeamStore().getOnCallTeamChoices();

  return (
    <Et3Table
      columns={ON_CALL_TEAM_HEADERS}
      rows={onCallTeamMembers}
      title={i18n.get("ON_CALL_TEAM")}
      shouldBeFlagged={false}
      titleKey={"ON_CALL_TEAM"}
    />
  );
});

export default OnCallTeamData;
